import produce from "immer";
import Tour from "./tour.js";
import ScreenSize from "./screen-size.js";

function create() {
  const tour = Tour.makeModalTour();

  // Highlightable Elements
  const newEntryButton =
    "[data-tour=new-entry-button] button:not([style='display:none'])";
  const quickTimerButton = "[data-tour=quick-timer-button] svg";
  const firstDeleteFeeButton = "[data-tour=fee-item] [data-tour=delete-button]";

  // Steps
  const steps = [
    {
      title: "Welcome to Mitimes!",
      text: "Let us briefly show you around to help get you started...",
      buttons: [{ text: "Let's go!", action: tour.next }],
    },

    Tour.highlightElStep(
      tour,
      "This is your main Timesheet where fees are entered",
      { show: "#timesheet-page .fees" },
      "top",
    ),

    produce(
      Tour.highlightElStep(
        tour,
        "Later, we'll turn on activity tracking for automation, but first...",
        { show: "#activity-feed-tab-trigger" },
        "top",
      ),
      (step) => {
        step.showOn = () => ScreenSize.isMaxWidth("1199px");
      },
    ),

    produce(
      Tour.highlightElStep(
        tour,
        "Later, we'll turn on activity tracking for automation, but first...",
        { show: "[data-tour=activity-feed]" },
        "top",
      ),
      (step) => {
        step.showOn = () => ScreenSize.isMinWidth("1200px");
      },
    ),

    Tour.highlightElStep(
      tour,
      "This is the New Entry button for creating a new Timesheet fee entry.",
      { show: newEntryButton },
    ),

    Tour.highlightElStep(
      tour,
      "This is the button for creating a new fee with a running timer.",
      { show: quickTimerButton },
    ),

    Tour.clickElStep(
      "Let's try creating a new fee. <strong>Please click here</strong>. Don't worry, you can delete it afterwards.",
      newEntryButton,
    ),

    Tour.highlightElStep(
      tour,
      "When you create a fee it appears in the timesheet " +
        "and is immediately ready to edit ",
      { show: "#fee-form" },
      "top",
    ),

    Tour.highlightElStep(
      tour,
      "You can change the date of your fee entry here",
      { show: "#fee-form [data-tour=date-input]" },
    ),

    Tour.highlightElStep(
      tour,
      "The time of your fee entry can be changed entry here",
      { show: "#fee-form [data-tour=time-input]" },
    ),

    Tour.highlightElStep(
      tour,
      'You can click here to set the activity type,\nsuch as "Meeting" or "Drafting".',
      { show: "#fee-form #open-fee-type svg" },
      "top",
    ),

    Tour.highlightElStep(
      tour,
      "The description as shown on the bill is editable here, " +
        "except the prefix - which is pre-filled as applicable " +
        "from the fee type.",
      { show: "#fee-form [data-tour=billing-description-component]" },
      "top",
    ),

    Tour.highlightElStep(
      tour,
      "If this text area is too small, you can drag the handle " +
        "at the bottom-right corner to make it larger.",
      { show: "#fee-form [data-tour=billing-description-component]" },
      "right",
    ),

    Tour.highlightElStep(
      tour,
      "You can enter the number of units here,\n" +
        "or use the number buttons on the right.\n" +
        "You can also start/pause a timer here.",
      { show: "#fee-form [data-tour=unit-block]" },
      "top",
    ),

    Tour.highlightElStep(
      tour,
      "Select the correct billing option for your fee. Options available are dependent on your PMS.",
      { show: "#fee-form [data-tour=billing-behaviour-select]" },
      "top",
    ),

    Tour.highlightElStep(tour, "You can select the matter here", {
      show: "#fee-form [data-tour=matter-selector]",
    }),

    Tour.clickElStep(
      "Let's close this fee, by <strong>clicking this 'x'</strong>",
      "#fee-form [data-tour=close-fee-cross]",
    ),

    Tour.clickElStep(
      "You can delete fee entries through this button.\n<strong>Please click</strong> now to delete this fee.",
      firstDeleteFeeButton,
      "left",
    ),
    {
      title: "That's all for now!",
      text:
        "Now you know how manual fees work, why not input a few actual entries to get the feel of it - or give the timer a try? " +
        "<br/>" +
        "<br/>" +
        "When you're ready, turn on Activity tracking to really get Mitimes working for you." +
        "<br/>" +
        "<br/>" +
        "Reach out to us at anytime by clicking 'Help & Support' at the bottom left." +
        "<br/>" +
        "<br/>" +
        "Bye for now!",
      buttons: [{ text: "Done", action: tour.complete }],
    },
  ];

  steps.forEach(tour.addStep);
  return tour;
}

export default { create };
